import NewsCard from './NewsCard';

export { NewsCard };
export default NewsCard;
